export default __webpack_public_path__ + "2b2925fdd5c9a4b0704cddbb65b464dd.png";